import { ArrowUpRight } from 'lucide-react'

import { ButtonGroup, Modal, TextLink } from 'slab'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function WhyBilledMoreThanOneMonthModal ({ open, onOpenChange }: Props) {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      width='medium'
      aria-describedby={undefined}
    >
      <Modal.Header>
        <Modal.Title>
          Why was I billed for more than 1 month of premiums?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='body-sm'>
          You may see what appears to be "double" billing for some employees. This occurs when newly invited employees (such as new hires or contractors who become eligible for benefits) enroll in insurance coverage after the previous billing period closes, so Thatch paid for their insurance coverage in their first month.{' '}
          <TextLink
            href='https://support.thatch.com/invoices-and-billing'
            target='_blank'
            rel='noopener noreferrer'
            color='purple'
            rightIcon={ArrowUpRight}
          >
            Learn more
          </TextLink>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup align='right'>
          <Modal.Button
            variant='primary'
            onClick={() => {
              onOpenChange(false)
            }}
          >
            Close
          </Modal.Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  )
}
